import React from 'react'
import Header from '../Comman/Header'
import Footer from '../Comman/Footer'
import Hero from './Hero'
import About from './About'
import Client from './Client'
import Product from './Product'
import WhatWeDo from './WhatWeDo'
import FAQ from './FAQ'
import Blog from './Blog'
import StartUsing from './StartUsing'
import Global from './Global'
import OurStory from './OurStory'
import PresaleCard from './PresaleCard'
import Slide from './Slider'

export default function Index() {
  return (
    <>
      <div className="bg-black header-crossed">
        <Header /> 
        <Hero />
       <PresaleCard/>
        <About />
        <Product />
        <OurStory/>
         <Slide />
        {/* <WhatWeDo /> */}  
        <StartUsing />
        <Global/>
        <Blog />
        <Client />
        <FAQ />
        <Footer />
      </div>
    </>
  )
}
